import axios from 'axios';
//import * as authActions from '../actions/auth';
//import React from "react";
//import { test } from '../components/Auth';
//import * as notificationActions from '../actions/notifications'

const BASE_URL = process.env.REACT_APP_API_URL;
//console.log(process.env);
//const { notify } = notificationActions;
let CancelToken = axios.CancelToken;
let cancel;
let api = {};

/*const test = (context) => {
    console.log(`context:`, context);
    const isAuthenticated = React.useContext(context);
    console.log(`isAuthenticated:`, isAuthenticated);
    return isAuthenticated
}*/

const ApiClient = axios.create({ //all axios can be used, shown in axios documentation 
	baseURL: BASE_URL,
	responseType: 'json',
    //withCredentials: true
    cancelToken: new CancelToken( c => {
        cancel = c;
    })
});
//console.log(`test:`, test());
// Add a request interceptor
ApiClient.interceptors.request.use(function (config) {
    config.headers = config.headers || {};
    let accessToken = localStorage.authToken;
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    if (localStorage.socket_id) {
        config.headers.SocketID = localStorage.socket_id;
    }
    //console.log(config);
    return Promise.resolve(config);
}, function (error) {
    //console.log(error);
    return Promise.reject(error);
});

ApiClient.interceptors.response.use(response => Promise.resolve(response), function (error) {
	
	//console.log(error);
	//console.log(error.response.status);
	//console.log(error.response.headers);
	// Do something with response error
	if(error.response !== undefined && error.response.status === 401 && error.config && !error.config.__isRetryRequest){
		/*this.store.dispatch(notify({
	      
	      message: error.response.status,
	      //kind: 'error',
	      //dismissAfter: 2
        }));*/
        
        //console.log(`Auth error:`);
        //console.log(this.context.handleLogout());
        
        //console.log(`Auth:`, test(this.context));
        //this.store.dispatch(authActions.logout({ type: 'danger'}));
        this.store.dispatch({ type: 'LOGOUT'});
        
		//localStorage.removeItem("authToken");
		//console.log('refresh token required');
		//console.log(error.config);
		
		/*return getRefreshToken()
	        .then(function (response) {
	            
	            //console.log('TOKEN RECEIVED', response);
	            //console.log('TOKEN:', response.data.token);
	            localStorage.authToken = response.data.token;
	            error.config.__isRetryRequest = true;
	            error.config.headers.Authorization = 'Bearer ' + response.data.token;
	            //error.config.url = '/'; // JUST TEST IF OK
	            //return ApiClient(error.config);
	            
	        })
	        .catch(function (err) {
	            //console.log('Refresh login error: ', err);
	            throw err;
	        });*/
        
	}
	//Object.keys(error).forEach(key => console.log(key));
		//console.log(error.status);
/*
	if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
*/
	//console.log(error.config);	
	return Promise.reject(error);
	
}.bind(ApiClient));

/*function getRefreshToken() {
    //console.log('TRYING TO GET TOKEN...');
    return ApiClient({
        //url: '/users/refresh_token'
        url: '/users/login',
        method: 'post',
        data: {email: 'vasilis@wapp.gr', password: 'password'}
    });
}*/

/*
ApiClient.interceptors.response.use(undefined, function (error) {
    if (error.status === 404 && error.config && !error.config.__isRetryRequest) {
        console.log('ACCESS TOKEN EXPIRED!');
        return getRefreshToken()
        .then(function (response) {
            console.log('TOKEN RECEIVED', response);
            error.config.__isRetryRequest = true;
            error.config.headers.Authorization = 'Bearer ' + response.data;
            error.config.url = 'exists.txt'; // JUST FOR TEST
            return axios(error.config);
        })
        .catch(function (error) {
            console.log('Refresh login error: ', error);
            throw error;
        });
    }
    throw error;
});
*/
api = ApiClient;
export { cancel }
export default api;